export const oneAppProjects = [
  {
    name: 'Home',
    url: '/one-app/projects',
    icon: 'fa fa-cube'
  },
  {
    name: 'Add Project',
    url: '/one-app/projects/new',
    icon: 'icon-plus'
  }
];
